import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Badge } from 'reactstrap';
import startCase from 'lodash/startCase';
import { formatMethodValue, formatMethodValuesArray } from '../../../../utils/methodFormatter';

// Local Deps
import './SearchBadge.scss';

/*
* This value dictates the number of displayed items
* for value property that is an array.
* Must be a minimum of 2.
*/
// const SEARCH_BADGE_DISPLAY_MAX = 2;

export default class SearchBadge extends PureComponent {
  static propTypes = {
    name: PropTypes.string,
    value: PropTypes.any,
    text: PropTypes.string,
  };

  static defaultProps = {
    name: '',
    value: '',
    text: '',
  };

  static _formatValuesArray(valuesArray, name) {
    let formattedValues;
    
    // For methods, use the method formatter to preserve slashes
    if (name === 'methods') {
      const formattedMethodValues = formatMethodValuesArray(valuesArray);
      formattedValues = formattedMethodValues.join(', ');
    } else {
      // For other fields, use startCase
      const titleCasedValues = valuesArray.map(val => startCase(val));
      formattedValues = titleCasedValues.join(', ');
    }
    
    return formattedValues;
  }

  render() {
    const { name, value, text } = this.props;
    /* 
    * If a user passes in a "text" prop,
    * exit early and just show that text in the badge.
    */
    if (text) {
      return (
        <Badge className="nf-search-badge" color="none">
          {text}
        </Badge>
      );
    }
    const formattedValue = Array.isArray(value) ? SearchBadge._formatValuesArray(value, name) : (name === 'methods' ? formatMethodValue(value) : value);
    const formattedName = startCase(name);
    let colorStyle = {};
    let { materials, methods, minQty, minEstCost } = '';
    
    // Check if value is empty (handles both arrays and strings)
    const isEmpty = Array.isArray(value) 
      ? (value.length === 0 || formattedValue.length === 0)
      : (!formattedValue || formattedValue.length === 0);
    
    if (name === 'materials') {
      materials = `${formattedName}: ${isEmpty ? "NO BID MATCHING SELECTED FOR MATERIALS!" : formattedValue}`;
      if (isEmpty) { colorStyle = { color: 'red' } }
    } else if (name === 'methods') {
      methods = `${formattedName}: ${isEmpty ? "NO BID MATCHING SELECTED FOR METHODS!" : formattedValue}`;
      if (isEmpty) { colorStyle = { color: 'red' } }
    } else if (name === 'minQuantity') {
      minQty = `${formattedName}: ${formattedValue}`;
    } else if (name === 'minEstimatedCost') {
      minEstCost = `${formattedName}: ${formattedValue}`;
    }
    return (
      <div>
        <span className="badge nf-search-badge nf-search-badge__name" style={colorStyle}>{materials}</span>
        <span className="badge nf-search-badge nf-search-badge__name" style={colorStyle}>{methods}</span>
        <span className="badge nf-search-badge nf-search-badge__name" >{minQty}</span>
        <span className="badge nf-search-badge nf-search-badge__name" >{minEstCost}</span>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/SolicitationsSearchBar/subComponents/SearchBadge/SearchBadge.jsx